const TARGET_CASE = {
    camel: 'camel',
    snake: 'snake',
};

function convertFromKebabCase(value, targetCase) {
    switch (targetCase) {
        case TARGET_CASE.snake:
            return value.replace(/-/g, '_');

        case TARGET_CASE.camel:
        default:
            return value.replace(/-([a-z])/g, (match) => match[1].toUpperCase());
    }
}

export default convertFromKebabCase;
export { TARGET_CASE };